import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkApiConfig } from "@shared/models/redux";
import { BackendFolder } from "@dataRoomSetup/models";

export const fetchFolderStructure = createAsyncThunk<BackendFolder[], number, ThunkApiConfig>(
  "dataRooms/fetchFolderStructure",
  async (id, { getState, extra, rejectWithValue }) => {
    try {
      const {
        user: { data: userData },
      } = getState();

      const response = await extra<any>(`/documents/v1/CustomDataroom/initalizeFolder/${userData!.id}/${id}`, {
        method: "post",
      });

      if (!response || response.status === 204) {
        return [] as BackendFolder[];
      }

      return (response.data?.resources ?? []) as BackendFolder[];
    } catch (error) {
      return rejectWithValue("Failed to fetch folder structure");
    }
  }
);
